<template>
    <template v-if="!$page.props?.dogdom?.user?.subscribed">
        <Alert type="promotion">
            <template #actions>
                <Link :href="route('my.subscriptions.index')"
                      class="whitespace-nowrap font-bold text-yellow-700 hover:text-yellow-800"
                >
                    Details
                    <span aria-hidden="true"> &rarr;</span>
                </Link>
            </template>

            Sign up before May to receive one month of free Dogdom membership, and get your photos up!
        </Alert>
    </template>
</template>

<script setup>
import {Link} from '@inertiajs/vue3';
import Alert  from '@/js/Components/Alert.vue';
</script>